module.exports = __webpack_public_path__ + "static/media/light5.39cd2e6d.png";